module.exports = __webpack_public_path__ + "static/media/gold.a2d1d468.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/cattributes/gold.svg
// module id = 165
// module chunks = 0